import { MetricsObserver } from "../event-observer";

class StoreAppEvents {
    constructor(options = {}) {
        this.options = options;
        this.name = "StoreApp Events";
    }

    /**
     *
     * @method pageView
     * @param {String} eventName
     * @param {Object} params
     * @returns {Promise}
     * @internal
     */
     
    pageView(...args) {
        return this.track(...args);
    }

    /**
     *
     * @method track
     * @param {String} eventName
     * @param {Object} params
     * @returns {Promise}
     * @internal
     */

    track(eventName, params) {
        const {event = ""} = params;
        MetricsObserver.publish( event, params );
    }

}

export default StoreAppEvents;